import { Button } from '@mui/material';
import {FC, useState} from 'react';
import { ClientJobFunctionDto } from '../../../dtos';
import { ViewJobFunctionMembersModal } from '../../Plays';
import { Plumbing } from '@mui/icons-material';

export interface IViewJobFunctionMembersButtonProps {
    jobFunction?: ClientJobFunctionDto;
};

export const ViewJobFunctionMembersButton: FC<IViewJobFunctionMembersButtonProps> = ({ jobFunction }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    return (
        <>
            <Button
                disabled={!jobFunction}
                variant='contained'
                fullWidth
                startIcon={<Plumbing />}
                onClick={() => setIsOpen(true)}>
                View Job Function Members
            </Button>
            <ViewJobFunctionMembersModal isOpen={isOpen} jobFunction={jobFunction} onClose={() => setIsOpen(false)} />
        </>
    );
};